import React from 'react';
import { SplashContainerStyled } from './styled';
import { connect } from 'react-redux';
import { userService } from 'apiServices';
import { withTranslation } from 'react-i18next';
import { setReduxAuthen } from 'store/actions';
import queryString from 'query-string';
import { withRouter } from 'navigations/withRouter';
import { ROUTE_PATH } from 'utils/constants/routePath';
import { Displays } from 'components';

class SplashContainer extends React.Component {
  state = {};
  isInitializing = false;

  componentDidMount() {
    this.initialLineLiff();
  }

  initialLineLiff = async () => {
    if (this.isInitializing) return;
    this.isInitializing = true;
    try {
      const liff = window.liff;
      if (!liff) {
        console.error('LIFF SDK not loaded');
        return;
      }

      const { page } = queryString.parse(this.props.router.location.search);

      await liff.init({
        liffId: `1657310383-jD5Benqp`,
        withLoginOnExternalBrowser: true,
      });

      if (!liff.isLoggedIn()) {
        liff.login();
        return;
      }

      const accessToken = liff.getAccessToken();
      const getProfile = await liff.getProfile();
      const params = {
        access_token: accessToken,
        user_id: getProfile.userId,
      };
      const res = await userService.POST_LINE_LOGIN(params);
      if (!res || res.status !== 200) {
        console.error('LINE login failed', res);
        return;
      }

      localStorage.setItem('token', res.token);
      const resProfile = await userService.GET_MY_PROFILE();
      if (!resProfile || resProfile.status !== 200) return;

      this.props.setReduxAuthen(resProfile.data);
      if (!resProfile.data.phone_number || !resProfile.data.province) {
        this.props.router.navigate(ROUTE_PATH.REGISTER);
      } else if (!page) {
        this.props.router.navigate(ROUTE_PATH.PRODUCT_SCAN_QR_CODE);
      } else {
        this.props.router.navigate(ROUTE_PATH[page]);
      }
    } catch (err) {
      console.error('initialLineLiff error', err);
    } finally {
      this.isInitializing = false;
    }
  };

  render() {
    return (
      <SplashContainerStyled useSuspense={false}>
        {/* <img alt="smp logo" src="/assets/images/logos/logo.png" /> */}
        <Displays.Loading />
      </SplashContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxAuthen: (data) => dispatch(setReduxAuthen(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation('translation')(withRouter(SplashContainer)));
